module.exports = __webpack_public_path__ + "static/media/soya.9df90d12.svg";